import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/shape-20.png'
import _imports_1 from '@/assets/images/shape-21.png'


const _hoisted_1 = { class: "container mw-1720" }
const _hoisted_2 = { class: "page-banner-content" }
const _hoisted_3 = { class: "d-flex align-items-center ps-0 list-unstyled bredcrounbs" }
const _hoisted_4 = {
  key: 0,
  class: "container mw-1356"
}
const _hoisted_5 = { class: "page-banner-img" }
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'page-banner-area bg-secondary overflow-hidden',
      { 'hide-banner': _ctx.hideBanner },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, { to: "/" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" HOME ")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.pageTitle), 1)
          ])
        ]),
        _createElementVNode("h2", null, _toDisplayString(_ctx.subTitle), 1)
      ])
    ]),
    (!_ctx.hideBanner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.pageBannerImage,
              alt: `Banner image for ${_ctx.pageTitle}`
            }, null, 8, _hoisted_6)
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      src: _imports_0,
      class: "shape-21 shape",
      alt: "shape"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      src: _imports_1,
      class: "shape-22 shape",
      alt: "shape"
    }, null, -1))
  ], 2))
}